var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDmHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 51,
    viewBox: "0 0 62 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6339 29.5114C64.7591 43.3461 47.1097 45.9179 37.8944 45.4745C29.831 46.488 11.7509 46.7287 3.93788 39.5833C-5.82834 30.6516 3.63738 11.0778 20.6156 4.99664C37.5938 -1.08454 57.7274 12.218 61.6339 29.5114Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63647 45.6126H24.2459H24.2878V45.6124H51.6045C51.9402 45.6124 52.2339 45.3606 52.2339 44.983V37.514C52.2339 37.1783 51.9822 36.9265 51.6465 36.9265H24.2878V26.0588H18.6651C17.7839 26.0588 17.0286 26.5204 16.609 27.2757L13.462 33.0243L8.51059 34.2832C7.62941 34.493 7 35.2902 7 36.2133V43.9761C7 44.8992 7.75529 45.6126 8.63647 45.6126Z",
    fill: "url(#paint0_linear_8908_435)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9607 40.9548C40.3592 40.9548 38.3031 43.0529 38.3031 45.6125C38.3031 48.2141 40.4011 50.2701 42.9607 50.2701C45.5623 50.2701 47.6184 48.1721 47.6184 45.6125C47.6184 43.0109 45.5204 40.9548 42.9607 40.9548Z",
    fill: "#4D5054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9604 43.1367C41.6177 43.1367 40.4847 44.2277 40.4847 45.6124C40.4847 46.9552 41.5757 48.0881 42.9604 48.0881C44.3032 48.0881 45.4361 46.9971 45.4361 45.6124C45.4361 44.2697 44.3032 43.1367 42.9604 43.1367Z",
    fill: "#B0B6BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5038 40.9548C10.9023 40.9548 8.84619 43.0529 8.84619 45.6125C8.84619 48.2141 10.9442 50.2701 13.5038 50.2701C16.1054 50.2701 18.1615 48.1721 18.1615 45.6125C18.2034 43.0109 16.1054 40.9548 13.5038 40.9548Z",
    fill: "#4D5054"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5035 43.1367C12.1608 43.1367 11.0278 44.2277 11.0278 45.6124C11.0278 46.9552 12.1188 48.0881 13.5035 48.0881C14.8463 48.0881 15.9792 46.9971 15.9792 45.6124C15.9792 44.2697 14.8882 43.1367 13.5035 43.1367Z",
    fill: "#B0B6BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8288 31.4718H48.5837V28.3667C48.5837 28.1988 48.4578 28.031 48.248 28.031H40.0237C39.8558 28.031 39.688 28.1569 39.688 28.3667V36.591C39.688 36.7589 39.8139 36.9267 40.0237 36.9267H48.248C48.4158 36.9267 48.5837 36.8008 48.5837 36.591V35.5H51.6888C52.0664 35.5 52.3601 35.2063 52.3601 34.8287C52.3601 34.451 52.0664 34.1573 51.6888 34.1573H48.5837H46.6115C46.2339 34.1573 45.9401 33.8636 45.9401 33.4859C45.9401 33.1083 46.2339 32.8145 46.6115 32.8145H48.5837H53.8288C54.2064 32.8145 54.5001 32.5208 54.5001 32.1432C54.5001 31.8075 54.2064 31.4718 53.8288 31.4718Z",
    fill: "url(#paint1_linear_8908_435)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4093 34.1992C53.0316 34.1992 52.7379 34.4929 52.7379 34.8706V34.9126C52.7379 35.2902 53.0316 35.5839 53.4093 35.5839C53.7869 35.5839 54.0807 35.2902 54.0807 34.9126V34.8706C54.0387 34.4929 53.745 34.1992 53.4093 34.1992Z",
    fill: "#CA9114"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9882 36.9265V28.0728H40.0231C39.8552 28.0728 39.6874 28.1986 39.6874 28.4084V36.6328C39.6874 36.8006 39.8133 36.9684 40.0231 36.9684H40.9882V36.9265Z",
    fill: "#CA9114"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5896 29.7931L43.6735 29.8771L43.7575 30.0029L43.7994 29.8771L43.8834 29.7931L43.9253 29.8771L44.0092 30.0029L44.0512 29.8771L44.1351 29.7931L44.1771 29.8771L44.261 30.0029L44.303 29.8771L44.3869 29.7931L44.4288 29.8771L44.5128 30.0029L44.5967 29.8771L44.6386 29.7931L44.7226 29.8771L44.7645 30.0029V28.0728H43.4637V30.0029L43.5477 29.8771L43.5896 29.7931Z",
    fill: "#CA9114"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7915 21.4851H39.1421C39.4358 21.4851 39.6875 21.7369 39.6875 22.0306V36.3812C39.6875 36.6749 39.4358 36.9267 39.1421 36.9267H24.7915C24.4977 36.9267 24.246 36.6749 24.246 36.3812V22.0306C24.246 21.7369 24.4977 21.4851 24.7915 21.4851Z",
    fill: "url(#paint2_linear_8908_435)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4699 36.9267V21.4851H24.7915C24.4977 21.4851 24.246 21.7369 24.246 22.0306V36.3812C24.246 36.6749 24.4977 36.9267 24.7915 36.9267H26.4699Z",
    fill: "#CA9114"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0437 24.4643L31.1695 24.6741L31.2954 24.8839L31.3794 24.6741L31.5052 24.4643L31.6311 24.6741L31.715 24.8839L31.8409 24.6741L31.9668 24.4643L32.0927 24.6741L32.1766 24.8839L32.3025 24.6741L32.4284 24.4643L32.5123 24.6741L32.6382 24.8839L32.7641 24.6741L32.848 24.4643L32.9739 24.6741L33.0997 24.8839V21.4851H30.8339V24.8839L30.9597 24.6741L31.0437 24.4643Z",
    fill: "#CA9114"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.246 43.9761H38.5546C38.3868 44.4796 38.2609 45.0251 38.2609 45.6125H24.246V43.9761Z",
    fill: "#4D5054"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6179 45.6125C47.6179 45.0251 47.534 44.4796 47.3242 43.9761H52.1917V45.0251C52.1917 45.3608 51.9399 45.6125 51.6042 45.6125H50.5552H47.6179Z",
    fill: "#4D5054"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2456 43.9761V45.6125H18.2033C18.2033 45.0251 18.1193 44.4796 17.9095 43.9761H24.2456Z",
    fill: "#4D5054"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14 43.9761C8.97216 44.4796 8.84627 45.0251 8.84627 45.6125H8.63647C7.75529 45.6125 7 44.8992 7 43.9761H9.14Z",
    fill: "#4D5054"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8908_435",
    x1: -1,
    y1: 29.4998,
    x2: 55.75,
    y2: 48.2498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D7581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565F6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8908_435",
    x1: 39.688,
    y1: 28.6241,
    x2: 47.2566,
    y2: 42.2767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8908_435",
    x1: 24.246,
    y1: 22.5145,
    x2: 39.6875,
    y2: 39.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmHomeIcon);
export default __webpack_public_path__ + "static/media/dm-home-icon.ac74cc571870b910ebb9eef2583c43c1.svg";
export { ForwardRef as ReactComponent };